import { commoncodeConstants } from '../../constants'

const initialState = {
  data: [],
  isLoading: false,
  isFailure: false,
  co: {},
  coSub: [],
  isv: [],
  isCorpNumberCheck: ''
}

export default function commoncode(state = initialState, action) {
  switch (action.type) {

    /*********
     리스트
    **********/

    case commoncodeConstants.GETCOCLASS_REQUEST:
      return {
        ...state,
        isFailure: false,
      }
    case commoncodeConstants.GETCOCLASS_SUCCESS:
      let obj = Object.assign(state.co, action.response.data?.payload);
      return {
        ...state,
        co: obj,
        isFailure: false,
      }
    case commoncodeConstants.GETCOCLASS_FAILURE:
      return {
        // isLoading: false,
        isFailure: true,
      }

    case commoncodeConstants.GETCOSUBCLASS_REQUEST:
      return {
        ...state,
        // isLoading: !state.isLoading
        isFailure: false,
      }
    case commoncodeConstants.GETCOSUBCLASS_SUCCESS:
      return {
        ...state,
        coSub: action.response.data,
        isFailure: false,
      }
    case commoncodeConstants.GETCOSUBCLASS_FAILURE:
      return {
        // isLoading: false,
        isFailure: true
      }


    case commoncodeConstants.GETZIPADDRSFORISV_REQUEST:
      return {
        ...state,
        // isLoading: !state.isLoading
      }
    case commoncodeConstants.GETZIPADDRSFORISV_SUCCESS:
      return {
        ...state,
        isv: action.response.data
      }
    case commoncodeConstants.GETZIPADDRSFORISV_FAILURE:
      return {
        // isLoading: false,
        isFailure: true
      }

      case commoncodeConstants.GET_IDENTITY_REQUEST:
        return {
          ...state,
          isLoading: !state.isLoading,
        }
      case commoncodeConstants.GET_IDENTITY_SUCCESS:
        return {
          ...state,
          isCorpNumberCheck: action.response.data.data.data
        }
      case commoncodeConstants.GET_IDENTITY_FAILURE:
        return {
          isLoading: false,
          isFailure: true
        }

    default:
      return state
  }
}
